import { ElNotification } from 'element-plus'

export const NotifySuccess = (message: string, options?: any) => {
  ElNotification.success({
    message: message,
    position: 'bottom-left',
    ...options,
  })
}

export const NotifyError = (err: Error, title?: string, options?: any) => {
  ElNotification.error({
    title: title,
    message: err.message,
    position: 'bottom-left',
    ...options,
  })
}

export const NotifyFail = (failMsg: string, options?: any) => {
  ElNotification.error({
    message: failMsg,
    position: 'bottom-left',
    ...options,
  })
}

export const NotifyInfo = (message: string, options?: any) => {
  ElNotification.info({
    message: message,
    position: 'bottom-left',
    ...options,
  })
}

export const NotifyErrorWrapper = (title: string) => (err: Error) => {
  NotifyError(err, title)
}
export const NotifySuccessWrapper = (message: string) => () => {
  NotifySuccess(message)
}
